module.exports = "<div class=\"content-box\">\r\n  <h2 class=\"header-major\">Almost Finished...</h2>\r\n  <p>We need to confirm your email address.</p>\r\n  <p>To complete the subscription process, please click the link in the email we just sent you.</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/login-module/wait-list-check-email/wait-list-check-email.component.html
// module id = ../../../../../src/app/login-module/wait-list-check-email/wait-list-check-email.component.html
// module chunks = main